import { render } from "./ProductMoveMent.vue?vue&type=template&id=954ccaac"
import script from "./ProductMoveMent.vue?vue&type=script&lang=js"
export * from "./ProductMoveMent.vue?vue&type=script&lang=js"
script.render = render

export default script